import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './payment-vendor-interest-free-list_types.2';

export function getPaymentVendorInterestFreeList(variable?: null, options?: GqlRequestOptions) {
  const query = 'query GetPaymentVendorInterestFreeList { payment_vendor_interest_free_list { item_list { financial_company_code id installment_month min_amount vendor_type } } }';
  return gql_request<types.GetPaymentVendorInterestFreeList, null>('GetPaymentVendorInterestFreeList', query, variable, { use_consumer: true, ...options });
}

